import { ArrowRight, MapPin, UserRound, UsersRound, Wallet } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
const HERO_IMAGE = "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1674648/img/Heronew.png";
const SearchForm = () => <form action="/course-finder/" method="get" className="overflow-hidden border border-white/20 p-[8px] backdrop-blur-md shadow-[0_18px_42px_rgba(73,58,36,0.14)] rounded-tl-[20px] rounded-tr-[20px] rounded-br-[20px] rounded-bl-[20px] !bg-[rgba(76,123,15,1)]">
    <div className={["grid overflow-hidden rounded-[8px]", "bg-[#FFFDF7]", "lg:grid-cols-[1.05fr_1.28fr_1.15fr_0.9fr_180px]"].join(" ")}>
      {/* Destination */}
      <label className="flex min-h-[70px] items-center gap-3 border-b border-[#E5DED0] px-5 py-4 lg:border-b-0 rounded-2xl">
        <MapPin className="size-[18px] shrink-0 text-[#718078]" strokeWidth={1.55} aria-hidden="true" />

        <span className="min-w-0 flex-1">
          <span className="tlc-search-label block text-[9px] font-bold uppercase tracking-[0.055em]">
            Destination
          </span>

          <input type="text" name="tl_search" placeholder="Where are you going?" className={["tlc-search-value mt-1 w-full", "border-0 bg-transparent p-0", "text-[12px] font-normal leading-[1.3]", "outline-none ring-0"].join(" ")} />
        </span>
      </label>

      {/* Playing level */}
      <label className="flex min-h-[70px] items-center gap-3 border-b border-[#E5DED0] px-5 py-4 lg:border-b-0 lg:border-l">
        <UserRound className="size-[18px] shrink-0 text-[#718078]" strokeWidth={1.55} aria-hidden="true" />

        <span className="min-w-0 flex-1">
          <span className="tlc-search-label block text-[9px] font-bold uppercase tracking-[0.055em]">
            Playing Level / Handicap
          </span>

          <select name="playing_level" defaultValue="" aria-label="Playing level or handicap" className={["tlc-search-value mt-1 w-full", "cursor-pointer border-0 bg-transparent p-0", "text-[12px] font-normal leading-[1.3]", "outline-none ring-0"].join(" ")}>
            <option value="">Any level</option>
            <option value="beginner">Beginner</option>
            <option value="intermediate">Intermediate</option>
            <option value="advanced">Advanced</option>
            <option value="single-handicap">Single handicap</option>
          </select>
        </span>
      </label>

      {/* Travelling with */}
      <label className="flex min-h-[70px] items-center gap-3 border-b border-[#E5DED0] px-5 py-4 lg:border-b-0 lg:border-l">
        <UsersRound className="size-[18px] shrink-0 text-[#718078]" strokeWidth={1.55} aria-hidden="true" />

        <span className="min-w-0 flex-1">
          <span className="tlc-search-label block text-[9px] font-bold uppercase tracking-[0.055em]">
            Travelling With
          </span>

          <select name="travelling_with" defaultValue="" aria-label="Who are you travelling with?" className={["tlc-search-value mt-1 w-full", "cursor-pointer border-0 bg-transparent p-0", "text-[12px] font-normal leading-[1.3]", "outline-none ring-0"].join(" ")}>
            <option value="">Select group</option>
            <option value="solo">Solo</option>
            <option value="couple">Couple</option>
            <option value="friends">Friends</option>
            <option value="family">Family</option>
            <option value="business">Business or clients</option>
            <option value="group">Golf group</option>
          </select>
        </span>
      </label>

      {/* Budget */}
      <label className="flex min-h-[70px] items-center gap-3 border-b border-[#E5DED0] px-5 py-4 lg:border-b-0 lg:border-l">
        <Wallet className="size-[18px] shrink-0 text-[#718078]" strokeWidth={1.55} aria-hidden="true" />

        <span className="min-w-0 flex-1">
          <span className="tlc-search-label block text-[9px] font-bold uppercase tracking-[0.055em]">
            Budget
          </span>

          <select name="tl_price" defaultValue="" aria-label="Budget" className={["tlc-search-value mt-1 w-full", "cursor-pointer border-0 bg-transparent p-0", "text-[12px] font-normal leading-[1.3]", "outline-none ring-0"].join(" ")}>
            <option value="">Any budget</option>
            <option value="budget">Budget</option>
            <option value="mid-range">Mid-range</option>
            <option value="premium">Premium</option>
            <option value="luxury">Luxury</option>
          </select>
        </span>
      </label>

      {/* Search button */}
      <button type="submit" className={["tlc-search-submit", "flex min-h-[62px] items-center justify-center gap-3", "border-0 bg-[#BFFF00] px-5", "text-[11px] font-bold uppercase tracking-[0.055em]", "text-[#073F31]", "shadow-none transition-colors duration-200", "hover:bg-[#C8FF35]", "lg:min-h-[70px]"].join(" ")}>
        Find Courses

        <ArrowRight className="size-4" strokeWidth={1.8} aria-hidden="true" />
      </button>
    </div>
  </form>;
export default function HomeHero() {
  return <section id="home-hero" data-home-section="hero" aria-label="TeeListClub golf discovery" className="relative min-h-[720px] overflow-visible bg-[#073F31] lg:mb-0 lg:min-h-[850px]">
      <style>
        {`
          #home-hero {
            font-family: "Raleway", Arial, sans-serif !important;
          }

          #home-hero .tlc-hero-title,
          #home-hero .tlc-hero-title span {
            font-family: "Playfair Display", Georgia, "Times New Roman", serif !important;
            font-weight: 500 !important;
          }

          #home-hero p,
          #home-hero a,
          #home-hero button,
          #home-hero input,
          #home-hero select,
          #home-hero label {
            font-family: "Raleway", Arial, sans-serif !important;
          }

          #home-hero .tlc-search-label {
            color: #073F31 !important;
            font-weight: 700 !important;
          }

          #home-hero .tlc-search-value {
            color: #9AA49F !important;
            font-weight: 400 !important;
          }

          #home-hero .tlc-search-value::placeholder {
            color: #A3ACA7 !important;
            opacity: 1 !important;
          }

          #home-hero .tlc-search-value option {
            color: #29483E !important;
          }

          #home-hero .tlc-search-submit {
            border-radius: 0 7px 7px 0 !important;
          }

          @media (max-width: 1023px) {
            #home-hero .tlc-search-submit {
              border-radius: 0 0 7px 7px !important;
            }
          }
        `}
      </style>

      {/* Keep the Hero image clear. Do not add an overlay. */}
      <div className="absolute inset-0 z-0 overflow-hidden">
        <img src={HERO_IMAGE} alt="Coastal golf course in Asia at sunrise" className="h-full w-full object-cover object-[57%_center]" />
      </div>

      {/* Hero wording positioned lower */}
      <div className={["relative z-10 mx-auto flex min-h-[720px]", "w-[88%] max-w-[1320px] items-center", "pb-[140px] pt-[210px]", "lg:min-h-[850px] lg:pb-[150px] lg:pt-[250px]"].join(" ")}>
        <div className="max-w-[650px]">
          <p className="mb-5 text-[14px] font-bold uppercase tracking-[0.18em] text-[#BFFF00] sm:text-[15px] lg:text-[18px]">
            Premium Golf Discovery for Asia
          </p>

      <h1 className={["tlc-home-hero-title", "max-w-[780px]", "text-[52px]", "leading-[0.96]", "tracking-[-0.045em]", "sm:text-[62px]", "md:text-[72px]", "lg:text-[82px]"].join(" ")}>
  <span className="block text-[#FFFDF7]">
    Find the course
  </span>

  <span className="block text-[#BFFF00]">
    that fits your trip.
  </span>
        </h1>

          <p className="mt-6 max-w-[590px] text-[17px] font-semibold leading-[1.55] text-[#FFFDF7]/90 sm:text-[18px] lg:text-[19px]">
            Search, compare and save the best golf courses across Asia.
            <span className="block">All in one place.</span>
          </p>

          <div className="mt-8 flex flex-col gap-4 sm:flex-row sm:items-center sm:gap-6">
            <Button asChild className="rounded-md justify-center whitespace-nowrap [&_svg]:pointer-events-none [&_svg:not([class*='size-'])]:size-4 shrink-0 [&_svg]:shrink-0 outline-none focus-visible:border-ring focus-visible:ring-ring/50 focus-visible:ring-[3px] aria-invalid:ring-destructive/20 aria-invalid:border-destructive py-2 has-[>svg]:px-3 h-[50px] bg-[#BFFF00] px-6 text-[13px] font-bold text-[#073F31] shadow-[0_8px_22px_rgba(191,255,0,0.16)] transition rounded-tl-[28px] rounded-tr-[28px] rounded-br-[28px] rounded-bl-[28px] inline-flex items-center gap-3 inline-flex items-center gap-3 !w-[240px] disabled:pointer-events-none disabled:opacity-50 dark:aria-invalid:ring-destructive/40 hover:-translate-y-px hover:bg-[#C8FF35]">
              <Link to="/course-finder/" className="inline-flex items-center gap-3">
                Find Courses for My Trip

                <ArrowRight className="size-4" strokeWidth={1.8} aria-hidden="true" />
              </Link>
            </Button>

            <Link to="/#home-destinations" className={["inline-flex items-center gap-2", "text-[14px] font-semibold text-[#FFFDF7]", "underline decoration-white/50", "underline-offset-[6px]", "transition hover:text-[#BFFF00]"].join(" ")}>
              Explore Destinations

              <ArrowRight className="size-4" strokeWidth={1.7} aria-hidden="true" />
            </Link>
          </div>
        </div>
      </div>

      {/* Mobile and tablet search */}
      <div className="relative z-30 mx-auto -mt-[70px] w-[92%] max-w-[1180px] lg:hidden">
        <SearchForm />
      </div>

      {/* Desktop search overlaps Hero and Value section */}
      <div className="absolute inset-x-0 bottom-[-46px] z-30 hidden lg:block">
        <div className="mx-auto w-[82%] max-w-[1180px]">
          <SearchForm />
        </div>
      </div>
    </section>;
}